// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"76":"531ea559","679":"2e36bce6","682":"ff127282"}[chunkId] + ".css";
};